<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
    name: "PollList",
    data() {
        return {
            has_error: false,
            search: '',
            headers: [
                {text: 'Nom', align: 'left', value: 'name'},
                {text: 'Questionnaire', align: 'left', value: 'score.name'},
                {text: 'Actions', align: 'left', value: 'actions', sortable: false}
            ],
            paginatorText: "Résultats par page",
            paginator: {
                rowsPerPage: 25,
                sortBy: 'name',
            },
            active: 0
        }
    },
    computed: mapState({
        polls: state => state.polls.polls
    }),

    methods: {
        ...mapActions('polls', [
            'getAllPolls',
            'getPollExport',
            'archivePoll',
            'restorePoll',
            'getArchivedPolls'
        ]),
        ...mapMutations('polls', [
            'setSelectedPollId',
            'setPolls'
        ]),

        exportPoll(id) {
            this.getPollExport(id).then(response => {
                let fileName = response.headers["content-disposition"].split("filename=")[1];
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                        fileName);
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
                    document.body.appendChild(link);
                    link.click();
                }
            }).catch(reason => {
                //Stay here..
            })
        },

        archive(id) {
            this.archivePoll(id);
        },

        restore(id) {
            this.restorePoll(id);
        },

        addPoll() {
            this.setSelectedPollId(null)
            this.$router.push({name: 'poll.add'})
        },
    },

    mounted() {
        this.getAllPolls()
    },

    watch: {
        active() {
            if(this.active === 0) {
                this.getAllPolls()
            } else {
                this.getArchivedPolls()
            }
        }
    }
}
</script>

<template>
    <v-card class="fill-height">
        <v-card-title primary-title>
            <h3 class="headline">Enquêtes</h3>
            <v-spacer></v-spacer>
            <v-btn right color="primary"  @click="addPoll">
                <v-icon>add</v-icon>
                Créer une enquête
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-layout align-center justify-end row>
                <v-flex xs6>
                    <v-tabs
                        v-model="active"
                        slider-color="primary">
                        <v-tab ripple>
                            Actives
                        </v-tab>
                        <v-tab ripple>
                            Archivées
                        </v-tab>
                    </v-tabs>
                </v-flex>
                <v-flex xs6>
                    <v-text-field v-model="search" append-icon="search" label="Recherche" single-line
                                  hide-details></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-data-table
            class="mx-4"
            :headers="headers"
            :items="polls"
            :search="search"
            :pagination.sync="paginator">
            <template v-slot:items="props">
                <tr>
                    <router-link tag="td" :to="{name: 'poll.edit', params: { id: props.item.id } }">
                    {{ props.item.name }}
                    </router-link>
                    <router-link tag="td" :to="{name: 'poll.edit', params: { id: props.item.id } }">
                        {{ props.item.score.name }}
                    </router-link>
                    <td>
                        <v-btn right color="primary" @click="exportPoll(props.item.id)">
                            <v-icon left>cloud_download</v-icon>
                            Export
                        </v-btn>
                        <v-btn right color="warning" @click="archive(props.item.id)" v-if="active === 0">
                            <v-icon left>archive</v-icon>
                            Archiver
                        </v-btn>
                        <v-btn right color="warning" @click="restore(props.item.id)" v-else>
                            <v-icon left>restore</v-icon>
                            Désarchiver
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Aucun résultat pour "{{ search }}".
                </v-alert>
            </template>
        </v-data-table>
    </v-card>
</template>
